"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../utils/epsilon-ajax-request");
var EpsilonPartialRefresh = /** @class */ (function () {
    /**
     * Handle the section partial refresh
     */
    function EpsilonPartialRefresh() {
        /**
         * Frontend sections
         */
        this.sections = [];
        /**
         * Register sections
         */
        this.registerSections();
        this.handleEvents();
    }
    /**
     * Register sectiosn
     */
    EpsilonPartialRefresh.prototype.registerSections = function () {
        var self = this;
        var $sections = jQuery('[data-customizer-section-id]');
        for (var i = 0; i < $sections.length; i++) {
            var id = jQuery($sections[i]).attr('data-section');
            var section = {
                id: parseInt(id),
                section: jQuery($sections[i]),
            };
            self.sections.push(section);
        }
    };
    /**
     * Handle events
     */
    EpsilonPartialRefresh.prototype.handleEvents = function () {
        var self = this;
        wp.customize.preview.bind('updated-section-repeater', _.debounce(function (object) {
            self.changeSection(object);
        }, 300));
    };
    /**
     * Change the section
     * @param object
     */
    EpsilonPartialRefresh.prototype.changeSection = function (object) {
        var self = this;
        var args = {
            action: ['Epsilon_Page_Generator', 'generate_partial_section'],
            nonce: EpsilonWPUrls.ajax_nonce,
            args: {
                control: object.control,
                postId: object.postId,
                id: object.index,
                value: object.value,
            }
        }, Ajax;
        Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
        Ajax.request();
        this.standBySection(self.sections[object.index].section);
        jQuery(Ajax).on('epsilon-received-success', function (e) {
            self.liveSection(object.index, self.sections[object.index].section, Ajax.result.section);
            jQuery(document).trigger('epsilon-selective-refresh-ready');
        });
    };
    /**
     * Stand by section
     * @param {JQuery} section
     */
    EpsilonPartialRefresh.prototype.standBySection = function (section) {
        section.animate({ opacity: .5 });
    };
    /**
     *
     * @param {JQuery} section
     */
    EpsilonPartialRefresh.prototype.liveSection = function (sectionIndex, section, result) {
        var self = this;
        section.replaceWith(result);
        self.sections = [];
        self.registerSections();
        section.animate({ opacity: 1 });
    };
    return EpsilonPartialRefresh;
}());
exports.EpsilonPartialRefresh = EpsilonPartialRefresh;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/partial-refresh/partial-refresh.ts
// module id = 33
// module chunks = 1